// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-details_titleIcon__S6Va\\+ {
  width: 60px;
  height: 60px;
}

@media only screen and (max-width: 768px) {
  .user-details_titleIcon__S6Va\\+ {
    width: 36px;
    height: 36px;
    margin-right: 12px;
  }
}

.user-details_cardWrapper__Qt0GD {
  display: flex;
  padding: 12px 12px;
  gap: 24px;
  border-bottom: 1px solid var(--mui-palette-grey-400);
  background: var(--mui-palette-primary-50);
}

@media only screen and (max-width: 768px) {
  .user-details_cardWrapper__Qt0GD {
    gap: 12px;
  }
}

.user-details_cardImage__5y9DD {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: var(--mui-palette-grey-400);
}

@media only screen and (max-width: 768px) {
  .user-details_userDetailsTableWrapper__-SQiR {
    max-width: calc(100vw - 30px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisation/manage-otps/user-details/index.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,oDAAoD;EACpD,yCAAyC;AAC3C;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".titleIcon {\n  width: 60px;\n  height: 60px;\n}\n\n@media only screen and (max-width: 768px) {\n  .titleIcon {\n    width: 36px;\n    height: 36px;\n    margin-right: 12px;\n  }\n}\n\n.cardWrapper {\n  display: flex;\n  padding: 12px 12px;\n  gap: 24px;\n  border-bottom: 1px solid var(--mui-palette-grey-400);\n  background: var(--mui-palette-primary-50);\n}\n\n@media only screen and (max-width: 768px) {\n  .cardWrapper {\n    gap: 12px;\n  }\n}\n\n.cardImage {\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  background: var(--mui-palette-grey-400);\n}\n\n@media only screen and (max-width: 768px) {\n  .userDetailsTableWrapper {\n    max-width: calc(100vw - 30px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleIcon": `user-details_titleIcon__S6Va+`,
	"cardWrapper": `user-details_cardWrapper__Qt0GD`,
	"cardImage": `user-details_cardImage__5y9DD`,
	"userDetailsTableWrapper": `user-details_userDetailsTableWrapper__-SQiR`
};
export default ___CSS_LOADER_EXPORT___;
